import React from "react";

export function Accordion({ children }: { children: React.ReactNode }) {
	return <div className="accordion">{children}</div>;
}
